module.exports = __webpack_public_path__ + "fonts/ABeeZee-Regularbe26f3332f3b4d552c823c5c045a46bb.ttf";